<div class="content">
  <ng-container>
    <glxy-form-field [required]="true">
      <glxy-label>{{ 'COMMON.EMAIL' | translate }}</glxy-label>
      <input matInput [formControl]="emailControl" [required]="true" id="email" />
      <automata-automation-variable-menu
        matSuffix
        useGalaxyCompat="true"
        dontIncludeDefaultCategories="true"
        (variableSelected)="insertVariable('email', emailControl, $event)"
      ></automata-automation-variable-menu>
    </glxy-form-field>
    <glxy-alert>
      {{ 'AUTOMATIONS.EDITOR.TASKS.GET_MY_TEAM_MEMBER.ALERT' | translate }}
    </glxy-alert>
  </ng-container>
</div>
